































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class dialogIframe extends Vue {
    @Prop({ type: Boolean, default: false }) dialogIframeShow!: boolean

    closeDialog() {
        this.$loading.hide()
        this.$emit('closeIframeDialog')
    }
    load() {
        this.$loading.hide()
    }
}
